import { useTranslation } from "react-i18next";

import type {
  IActionAlertVariantProps,
  IAlertButtonLoadingProps,
  IAlertButtonsType,
} from "@components/molecules/alert/types";
import { Button } from "@components/atoms/button";

export function ActionAlertButtons(
  props: IAlertButtonsType<IActionAlertVariantProps> & IAlertButtonLoadingProps,
) {
  const {
    onClose,
    onCancel,
    cancelTitle,
    approveTitle,
    onApprove,
    isLoading,
    setIsLoading,
  } = props;
  const { t } = useTranslation("common");

  return (
    <>
      <Button
        mode={"secondary"}
        onClick={() => {
          setIsLoading(false);
          if (onCancel) {
            onCancel();
          }
          onClose();
        }}
        disabled={isLoading}
      >
        {cancelTitle || t("cancel")}
      </Button>
      <Button
        mode={"main"}
        onClick={async () => {
          setIsLoading(true);
          if (onApprove) {
            await onApprove();
          }
          onClose();
          setIsLoading(false);
        }}
        isLoading={props.isLoading || isLoading}
      >
        {approveTitle || t("approve")}
      </Button>
    </>
  );
}
